// TO-DO 保证金退还页面的pc端与通用审核不一致，所以该页面的审核未处理
const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目基本信息',
        },
    },
    // 黄工TODO api文档中有银行信息
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getApproveStatusName } = require('../approveStatus')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
        },
        getBaseInfo() {
            const guid = this.form.businessKey.split(':')[1]
            this.$request.post(`/transformToAfter/app/deposit/refund/getDetail`, {
                sqGuid: guid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '招标项目名称': res.data.gcName,
                    '招标项目编号': res.data.gcBH,
                    '标段名称': res.data.bdName,
                    '标段编号': res.data.bdBH,
                    '项目经理': res.data.projectManagerName,
                    '联系方式': res.data.projectManagerPhone,
                    '总退款金额': res.data.tuiKuanJETotal,
                    '总服务费金额': res.data.fuWuFeiJETotal,
                    '附件': '',
                }
                this.getAuditList(res.data.approveRecordList)
            })
        },
        getAuditList(list) {
            this.config[this.config.length - 1].options.data = list.map((t) => ({
                '提交人': t.commitUserName,
                '提交事件': this.$util.timeFormatter(t.commitTime),
                '审批人': t.approveUserName,
                '审批结果': getApproveStatusName(t.statusMsg),
                '审核时间': this.$util.timeFormatter(t.approveTime),
                '审批意见': t.opinion,
            }))
        },
        pass() {
            // 黄工TODO
            // 文档中更新了相应api/app/deposit/refund/updateLaiKuanInfo
            // let { code } = await this.portService.tuiHuanForXianXia({ bzjGuid: this.guid });
        },
        fail(opinion) {
            //
        },
        // getAuditList(){
        //     // 黄工TODO
        //     // getBaseInfo方法里有approveRecordList,检查此方法是否需要重写
        // }
    },
}

module.exports = {
    config,
    mixin,
}
